import { useQuery } from "@apollo/client";

import {
  IPropertyIdVariable,
  IShowResidentsData,
} from "../../interfaces/interfaces";
import { GET_RESIDENT_INFO } from "../../api/gqlQueries";
import Spinner from "../Spinner";
import { UsersTables } from "../tables/UsersTables";

export interface IViewMembersProps {
  propertyId: string;
  openEditResidentModal: () => void;
  setShowInviteTenantModal: React.Dispatch<React.SetStateAction<boolean>>;
}

function AddMemberAction({
  setShowInviteTenantModal,
}: {
  setShowInviteTenantModal: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  setShowInviteTenantModal(true);
}

const ViewMembers: React.FC<IViewMembersProps> = ({
  propertyId,
  openEditResidentModal,
  setShowInviteTenantModal,
}) => {
  const { loading, data } = useQuery<IShowResidentsData, IPropertyIdVariable>(
    GET_RESIDENT_INFO,
    {
      variables: { propertyId },
    }
  );
  if (loading) {
    return <Spinner />;
  }
  if (!data) {
    throw Error("No data was returned");
  }
  const { home } = data;
  return (
    <>
      <UsersTables
        invitedPortalUsers={home.invitedResidents}
        portalUsers={home.residents}
        shouldEmptyTableRender={false}
        openRemoveFlowModal={() => undefined}
        shouldTrashRender={false}
        shouldGearRender
        openEditResidentModal={openEditResidentModal}
      >
        <div className="tenants-add-btn-container">
          <button
            data-testid="table-add-resident-btn"
            className="tertiary-btn-small"
            type="button"
            onClick={() =>
              AddMemberAction({
                setShowInviteTenantModal,
              })
            }
          >
            + Add Member
          </button>
        </div>
      </UsersTables>
      <div className="tenants-add-btn-container-small tenants-add-btn-container-full-width-pro-view">
        <button
          type="button"
          className="primary-btn tenants-add-btn-primary"
          onClick={() =>
            AddMemberAction({
              setShowInviteTenantModal,
            })
          }
        >
          Add Member
        </button>
      </div>
    </>
  );
};

export default ViewMembers;
